import BaseConfig from '@/config/base.js'

// mock本地调试
let useMock = false
let mockName = 'vava'
let mockLang = 'en'
const mockStrategies = {
  echo() { return mockName === 'echo' },
  joychat() { return mockName === 'joychat' },
  joyu() { return mockName === 'joyu' },
  kiko() { return mockName === 'kiko' },
  vava() { return mockName === 'vava' },
  vibeo() { return mockName === 'vibeo' },
  whonow() { return mockName === 'whonow' }
}

// 确保VUE_APP_CODE_STATE一定有值再用mock
if (process.env.VUE_APP_CODE_STATE) {
  useMock = process.env.VUE_APP_CODE_STATE !== 'product' && process.env.VUE_APP_CODE_STATE !== 'test'
  mockName = process.env.VUE_APP_CODE_STATE !== 'product' ? mockName : 'vava'
  mockLang = process.env.VUE_APP_CODE_STATE !== 'product' ? mockLang : 'en'
}
// 未知环境
else {
  useMock = false
  mockName = 'vava',
  mockLang = 'en'
}

// 正式环境mockFlag一定得是false
export const mockFlag = useMock
export const mockApp = mockName
export const mockLangType = mockLang

// 区分包-包名
export function appNameFlag(type, val) {
  let strategies = {
    echo() {
      if (BaseConfig.echoPackage.includes(val)) return true
    },
    joychat() {
      if (BaseConfig.joychatPackage.includes(val)) return true
    },
    joyu() {
      if (BaseConfig.joyuPackage.includes(val)) return true
    },
    kiko() {
      if (BaseConfig.kikoPackage.includes(val)) return true
    },
    vava() {
      if (BaseConfig.vavaPackage.includes(val)) return true
    },
    vibeo() {
      if (BaseConfig.vibeoPackage.includes(val)) return true
    },
    whonow() {
      if (BaseConfig.whonowPackage.includes(val)) return true
    }
  }

  // mock-本地调试
  if (useMock) {
    strategies = mockStrategies
  }

  return strategies[type] ? strategies[type]() : false
}

// 区分包-域名
export function domainNameFlag(type, val) {
  let strategies = {
    echo() {
      if (BaseConfig.echoHost.includes(val)) return true
    },
    joychat() {
      if (BaseConfig.joychatHost.includes(val)) return true
    },
    joyu() {
      if (BaseConfig.joyuHost.includes(val)) return true
    },
    kiko() {
      if (BaseConfig.kikoHost.includes(val)) return true
    },
    vava() {
      if (BaseConfig.vavaHost.includes(val)) return true
    },
    vibeo() {
      if (BaseConfig.vibeoHost.includes(val)) return true
    },
    whonow() {
      if (BaseConfig.whonowHost.includes(val)) return true
    }
  }

  // mock-本地调试
  if (useMock) {
    strategies = mockStrategies
  }

  return strategies[type] ? strategies[type]() : false
}
